<app-navbar [title]="data.first_name + ' ' + data.last_name">
	<a routerLink="./history" class="btn btn-secondary me-2"> <i class="fas fa-history"></i> Historia </a>
	<div class="btn btn-success me-2" *ngIf="!editable && selectedAction === 'rate'" (click)="rateSetModalOpen()">
		Dodaj stawkę
	</div>
	<div
		class="btn btn-primary me-2"
		*ngIf="(pageFunction === 'edit' && editable) || (pageFunction === 'add' && selectedAction !== 'rate')"
		(click)="sendData()"
	>
		Zapisz
	</div>
	<div
		class="btn btn-primary me-2"
		*ngIf="pageFunction === 'edit' && !editable && selectedAction !== 'rate'"
		(click)="editUnlock()"
	>
		Edycja
	</div>
	<a class="btn btn-danger me-2" routerLink="../"> <i class="fas fa-chevron-left"></i> Kierowcy </a>
	<a class="btn btn-danger" routerLink="../salary"> <i class="fas fa-chevron-left"></i> Wynagrodzenia </a>
</app-navbar>
<div class="container my-4">
	<ul class="nav nav-tabs" id="myTab" role="tablist">
		<li class="nav-item" [ngClass]="{ disabled: editable && selectedAction !== 'driver' }">
			<a
				class="nav-link active"
				id="podstawowe-tab"
				data-bs-toggle="tab"
				href="#podstawowe"
				role="tab"
				aria-controls="podstawowe"
				aria-selected="false"
				(click)="setAction('driver')"
				>Podstawowe</a
			>
		</li>
		<li class="nav-item" [ngClass]="{ disabled: editable && selectedAction !== 'driver' }">
			<a
				class="nav-link"
				id="documents-tab"
				data-bs-toggle="tab"
				href="#documents"
				role="tab"
				aria-controls="documents"
				aria-selected="false"
				(click)="setAction('driver')"
				>Dokumenty</a
			>
		</li>
		<li class="nav-item" [ngClass]="{ disabled: editable && selectedAction !== 'driver' }">
			<a
				class="nav-link"
				id="other-tab"
				data-bs-toggle="tab"
				href="#other"
				role="tab"
				aria-controls="other"
				aria-selected="false"
				(click)="setAction('driver')"
				>Inne</a
			>
		</li>
		<li class="nav-item" [ngClass]="{ disabled: editable && selectedAction !== 'rate' }">
			<a
				class="nav-link"
				id="stawki-tab"
				data-bs-toggle="tab"
				href="#stawki"
				role="tab"
				aria-controls="stawki"
				aria-selected="false"
				(click)="setAction('rate')"
				>Stawki</a
			>
		</li>
		<li class="nav-item" [ngClass]="{ disabled: editable && selectedAction !== 'salary' }">
			<a
				class="nav-link"
				id="other-tab"
				data-bs-toggle="tab"
				href="#salaryDays"
				role="tab"
				aria-controls="other"
				aria-selected="false"
				(click)="setAction('salary')"
				>Wynagrodzenie</a
			>
		</li>
		<li class="nav-item" [ngClass]="{ disabled: editable && selectedAction !== 'summary' }">
			<a
				class="nav-link"
				id="other-tab"
				data-bs-toggle="tab"
				href="#summary"
				role="tab"
				aria-controls="other"
				aria-selected="false"
				(click)="setAction('summary')"
				>Wynagrodzenie Podsumowanie</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="confirm-history-tab"
				data-bs-toggle="tab"
				href="#salary-confirm-history"
				role="tab"
				aria-controls="confirm-history"
				aria-selected="false"
				(click)="setAction('history')"
				>Historia zatwierdzeń</a
			>
		</li>
	</ul>
	<div class="my-4">
		<div class="tab-content col" id="myTabContent">
			<div class="tab-pane fade active show" id="podstawowe" role="tabpanel" aria-labelledby="podstawowe-tab">
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<div class="form-floating mb-3">
						<select
							class="form-select"
							id="status"
							name="status"
							[(ngModel)]="data.status"
							(change)="infoChangeWages()"
						>
							<option
								value="{{ item.id }}"
								*ngFor="let item of statuses"
								[disabled]="item.id === 'VIRTUAL'"
							>
								{{ item.name }}
							</option>
						</select>
						<label for="status">Status</label>
					</div>
					<div class="form-floating mb-3">
						<select class="form-select" id="companies" [(ngModel)]="data.companyId" name="companies">
							<option value="{{ item.id }}" *ngFor="let item of companies">
								{{ item.name }}
							</option>
						</select>
						<label for="driverKinds">Zatrudnienie</label>
					</div>
					<div class="form-floating mb-3">
						<select class="form-select" id="driverKinds" [(ngModel)]="data.driverKinds" name="driverKinds">
							<option value="{{ item.id }}" *ngFor="let item of driverKinds">
								{{ item.name }}
							</option>
						</select>
						<label for="driverKinds">Rodzaj kierowcy</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							name="whenContact"
							id="whenContact"
							[(ngModel)]="data.whenContact"
						/>
						<label for="whenContact">Data kontaktu</label>
					</div>
					<div class="form-floating mb-3">
						<input class="form-control" id="envoiID" name="envoiID" [(ngModel)]="data.envoiID" required />
						<label for="first_name">Enova ID</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							id="first_name"
							name="first_name"
							[(ngModel)]="data.first_name"
							required
						/>
						<label for="first_name">Imię</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							name="last_name"
							[(ngModel)]="data.last_name"
							id="last_name"
							required
						/>
						<label for="last_name">Nazwisko</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							name="birthdate"
							[(ngModel)]="data.birthdate"
							id="birthdate"
							required
						/>
						<label for="birthdate">Data urodzenia</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							name="phone_private"
							[(ngModel)]="data.phone_private"
							id="phone_private"
							required
						/>
						<label for="phone_private">Telefon prywatny</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							name="phone_business"
							[(ngModel)]="data.phone_business"
							id="phone_business"
						/>
						<label for="phone_business">Telefon służbowy</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="email"
							class="form-control"
							name="email_private"
							[(ngModel)]="data.email_private"
							id="email_private"
							required
						/>
						<label for="email_private">E-mail prywatny</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="email"
							class="form-control"
							name="email_business"
							[(ngModel)]="data.email_business"
							id="email_business"
						/>
						<label for="email_business">E-mail służbowy</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-select"
							id="nearest_city"
							[(ngModel)]="data.nearest_city"
							name="nearest_city"
						>
							<option value="">(brak)</option>
							<option value="{{ item.id }}" *ngFor="let item of cities">
								{{ item.name }}
							</option>
						</select>
						<label for="nearest_city">Najbliższe duże miasto</label>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab">
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<div class="d-flex bd-highlight">
						<div class="flex-fill bd-highlight">
							<div class="form-floating mb-3">
								<input
									type="date"
									class="form-control"
									id="dateIdCard"
									name="dateIdCard"
									[(ngModel)]="data.documents.idCard.date"
									[ngClass]="{
										'is-invalid': data.documents.idCard.date <= validationDate,
									}"
								/>
								<label for="dateIdCard">Termin dowodu osobistego</label>
							</div>
						</div>
					</div>
					<div class="d-flex bd-highlight">
						<div class="flex-fill bd-highlight">
							<div class="form-floating mb-3 me-4">
								<select
									class="form-select"
									id="isForeigner"
									[(ngModel)]="data.documents.foreigner.checkDocument"
									name="isForeigner"
									(change)="clearDate('isForeigner')"
								>
									<option value="{{ item.id }}" *ngFor="let item of yesno">
										{{ item.name }}
									</option>
								</select>
								<label for="isForeigner">Obywatel zagraniczny</label>
							</div>
						</div>
						<div class="flex-fill bd-highlight">
							<div class="form-floating mb-3 me-4">
								<input
									type="date"
									class="form-control"
									name="residenceCardDate"
									id="residenceCardDate"
									[(ngModel)]="data.documents.foreigner.date"
									[ngClass]="{
										'is-invalid': data.documents.foreigner.date <= validationDate,
									}"
									[disabled]="data.documents.foreigner.checkDocument !== '1'"
								/>
								<label for="residenceCardDate">Termin karty pobytu/wiza</label>
							</div>
						</div>
						<div class="flex-fill bd-highlight">
							<div class="form-floating mb-3">
								<input
									type="date"
									class="form-control"
									id="dateWorkPermit"
									name="dateWorkPermit"
									[(ngModel)]="data.documents.workPermit.date"
									[ngClass]="{
										'is-invalid': data.documents.workPermit.date <= validationDate,
									}"
									[disabled]="data.documents.foreigner.checkDocument !== '1'"
								/>
								<label for="dateWorkPermit">Termin pozwolenia na pracę</label>
							</div>
						</div>
					</div>
					<div class="d-flex bd-highlight">
						<div class="flex-fill bd-highlight">
							<div class="form-floating mb-3 me-4">
								<select
									class="form-select"
									id="trailer"
									[(ngModel)]="data.documents.trailer.checkDocument"
									name="trailer"
									(change)="clearDate('trailer')"
								>
									<option value="{{ item.id }}" *ngFor="let item of yesno">
										{{ item.name }}
									</option>
								</select>
								<label for="trailer">Przyczepka</label>
							</div>
						</div>
						<div class="flex-fill bd-highlight">
							<div class="form-floating mb-3">
								<input
									type="date"
									class="form-control"
									name="trailer"
									id="trailer"
									[(ngModel)]="data.documents.trailer.date"
									[ngClass]="{
										'is-invalid': data.documents.trailer.date <= validationDate,
									}"
									[disabled]="data.documents.trailer.checkDocument !== '1'"
								/>
								<label for="trailer">Termin ważności</label>
							</div>
						</div>
					</div>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							name="dateLicense"
							id="dateLicense"
							[ngClass]="{
								'is-invalid': data.documents.driverLicense.date <= validationDate,
							}"
							[(ngModel)]="data.documents.driverLicense.date"
						/>
						<label for="dateLicense">Termin prawo-jazdy</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							name="dateEta"
							id="dateEta"
							[ngClass]="{
								'is-invalid': data.documents.eta.date <= validationDate,
							}"
							[(ngModel)]="data.documents.eta.date"
						/>
						<label for="dateEta">ETA</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							name="dateQualification"
							id="dateQualification"
							[ngClass]="{
								'is-invalid': data.documents.qualification.date <= validationDate,
							}"
							[(ngModel)]="data.documents.qualification.date"
						/>
						<label for="dateQualification">Termin kwalifikacji</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							name="dateDriverCard"
							id="dateDriverCard"
							[ngClass]="{
								'is-invalid': data.documents.driverCard.date <= validationDate,
							}"
							[(ngModel)]="data.documents.driverCard.date"
						/>
						<label for="dateDriverCard">Termin karty kierowcy</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							name="datePassport"
							id="datePassport"
							[ngClass]="{
								'is-invalid': data.documents.passport.date <= validationDate,
							}"
							[(ngModel)]="data.documents.passport.date"
						/>
						<label for="datePassport">Termin paszportu</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							name="medicalCheckUp"
							id="medicalCheckUp"
							[ngClass]="{
								'is-invalid': data.documents.medicalCheckUp.date <= validationDate,
							}"
							[(ngModel)]="data.documents.medicalCheckUp.date"
						/>
						<label for="medicalCheckUp">Badania lekarskie</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="date"
							class="form-control"
							[ngClass]="{
								'is-invalid': data.documents.psychologyCheckUp.date <= validationDate,
							}"
							name="psychologyCheckUp"
							id="psychologyCheckUp"
							[(ngModel)]="data.documents.psychologyCheckUp.date"
						/>
						<label for="psychologyCheckUp">badania psychologiczne</label>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="stawki" role="tabpanel" aria-labelledby="stawki-tab">
				<app-drivers-rate-set [(driver)]="data.id"> </app-drivers-rate-set>
			</div>
			<div class="tab-pane fade" id="other" role="tabpanel" aria-labelledby="other-tab">
				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<div class="form-floating mb-3">
						<input
							type="number"
							min="0"
							max="10"
							class="form-control"
							id="rate"
							name="rate"
							[(ngModel)]="data.rate"
						/>
						<label for="rate">Ocena</label>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							id="comments"
							name="comments"
							[(ngModel)]="data.comments"
						></textarea>
						<label for="comments">Uwagi</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-select"
							id="chronically_ill"
							[(ngModel)]="data.chronically_ill"
							name="chronically_ill"
						>
							<option value="{{ item.id }}" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="chronically_ill">Przewlekle chory</label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-select"
							id="vaccinations"
							[(ngModel)]="data.vaccinations"
							name="vaccinations"
						>
							<option value="{{ item.id }}" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="vaccinations">Szczepienie COVID</label>
					</div>
					<div class="form-floating mb-3">
						<textarea class="form-control" id="salary" name="salary" [(ngModel)]="data.salary"></textarea>
						<label for="salary">Uwagi do rozliczeń</label>
					</div>
					<div class="form-check mb-3">
						<input
							type="checkbox"
							class="form-check-input"
							id="different_account_diet"
							[checked]="data.different_account_diet"
							[(ngModel)]="data.different_account_diet"
							name="different_account_diet"
						/>
						<label class="col-form-label" for="different_account_diet">Dieta na inne konto</label>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							id="bankaccount"
							name="bankaccount"
							[(ngModel)]="data.bankaccount"
						></textarea>
						<label for="bankaccount">Numer konta</label>
					</div>
				</fieldset>
				<app-drivers-diet-set
					[(driver)]="data.id"
					[selectedMonth]="selectedMonth"
					(changeMonth)="setMonth($event)"
				>
				</app-drivers-diet-set>
			</div>
			<div class="tab-pane fade" id="salaryDays" role="tabpanel" aria-labelledby="salary-tab">
				<app-drivers-select-month [editable]="editable" (changeMonth)="setMonth($event)">
				</app-drivers-select-month>

				<fieldset [disabled]="pageFunction !== 'add' && !editable">
					<app-drivers-salary-days-list
						[driver]="data.id"
						[selectedMonth]="selectedMonth"
						(sendDriverData)="getDriverData($event)"
						(sendBonusData)="getBonusData($event)"
						(sendSalaryBasicData)="getSalaryBasicData($event)"
						(changeMonth)="setMonth($event)"
					>
					</app-drivers-salary-days-list>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="summary" role="tabpanel" aria-labelledby="summary-tab">
				<div class="col">
					<div class="col-3 my-4">
						<input
							type="month"
							class="form-control me-2 ms-2"
							name="selectedMonth"
							id="selectedMonth"
							[(ngModel)]="selectedMonth"
							[disabled]="true"
						/>
					</div>
					<app-drivers-salary-summary-month
						[driverDays]="driverData"
						[driver]="data"
						[bonus]="bonusData"
						[salary]="salaryData"
						[editable]="editable"
						[salaryData]="selectedMonth"
						[selectedMonth]="selectedMonth"
						(sendHistoryConfirmed)="getConfirmedHistory($event)"
					>
					</app-drivers-salary-summary-month>
				</div>
			</div>
			<div class="tab-pane fade" id="salary-confirm-history" role="tabpanel" aria-labelledby="history-tab">
				<app-drivers-salary-confirm-history [data]="confirmedHistory"> </app-drivers-salary-confirm-history>
			</div>
		</div>
	</div>
</div>
